var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightGrayTrigger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 21,
    viewBox: "0 0 11 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.351799 18.2866C-0.109284 18.7403 -0.118052 19.4848 0.332214 19.9495C0.782481 20.4141 1.52128 20.423 1.98236 19.9692L10.5815 11.5068C11.0426 11.0531 11.0513 10.3086 10.6011 9.8439C10.56 9.80151 10.5165 9.76291 10.471 9.72811C10.42 9.59962 10.3454 9.47811 10.247 9.37013L2.05357 0.380428C1.61762 -0.0978915 0.879443 -0.129502 0.404799 0.309821C-0.0698445 0.749143 -0.101213 1.49304 0.334736 1.97135L8.18179 10.5811L0.351799 18.2866Z",
    fill: "#D4D4D4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightGrayTrigger);
export default __webpack_public_path__ + "static/media/right_gray_trigger.2f1377ae63b23dc85b7cd24c337456b2.svg";
export { ForwardRef as ReactComponent };